const KEYWORDS = [
  "Comercializadora",
  "Equipos electrónicos",
  "Logística",
  "Ventas",
  "Nexora",
  "Cómputo",
  "Comercio",
  "Importación",
  "Fibra Óptica",
  "Mayoreo",
  "Menudeo",
  "Telecomunicaciones",
];

export const Marquee = () => {
  return (
    <div
      data-testid="keyword-marquee"
      className="bg-[#3B3838] text-white border-y border-[#843C0C]/40 overflow-hidden"
    >
      <div className="marquee py-4">
        {[...KEYWORDS, ...KEYWORDS].map((k, i) => (
          <span
            key={i}
            className="font-mono-tech text-xs md:text-sm tracking-[0.3em] uppercase flex items-center gap-3 whitespace-nowrap"
          >
            <span className="h-1.5 w-1.5 bg-[#843C0C]" />
            {k}
          </span>
        ))}
      </div>
    </div>
  );
};
